import { CSSObject } from '@mui/material';

const sizes: CSSObject = {
  // Sizes Styling
  sizeSmall: {
    fontSize: '12px',

    padding: '4px'
  },
  sizeMedium: {
    fontSize: '14px',

    padding: '8px'
  },
  sizeLarge: {
    fontSize: '14px',

    padding: '16px'
  }
};

export default sizes;
